import { z } from 'zod';
import { FREIGHT_TYPE_SCHEMA, DISPOSAL_PURPOSE_SCHEMA } from '@schuettflix/interfaces';
import { AdditionalPropertiesIdSchema } from '../enums/additional-properties-schema-id.ts';
import { AbstractAdditionalProperties } from './abstract-additional-properties.ts';

/**
 * V1 Version of ManualTransport, where the freightType was not present yet.
 */
export const ManualTransportPropertiesSchemaV1 = z.object({
    ...AbstractAdditionalProperties.shape,
    schemaId: AdditionalPropertiesIdSchema.extract(['MANUAL_TRANSPORT_V1']),
});

export type ManualTransportPropertiesV1 = z.infer<typeof ManualTransportPropertiesSchemaV1>;

/**
 * V2 Version of ManualTransport, where the freightType was introduced as a mandatory field.
 */
export const ManualTransportPropertiesSchemaV2 = z.object({
    ...AbstractAdditionalProperties.shape,
    schemaId: AdditionalPropertiesIdSchema.extract(['MANUAL_TRANSPORT_V2']),
    freightType: FREIGHT_TYPE_SCHEMA.exclude(['HAZARDOUS_WASTE', 'NON_HAZARDOUS_WASTE']),
});

export type ManualTransportPropertiesV2 = z.infer<typeof ManualTransportPropertiesSchemaV2>;

export const ManualTransportWastePropertiesSchemaV1 = z.object({
    ...AbstractAdditionalProperties.shape,
    schemaId: AdditionalPropertiesIdSchema.extract(['MANUAL_WASTE_TRANSPORT_V1']),
    freightType: FREIGHT_TYPE_SCHEMA.extract(['HAZARDOUS_WASTE', 'NON_HAZARDOUS_WASTE']),
    disposalPurpose: DISPOSAL_PURPOSE_SCHEMA,
});

export type ManualTransportWastePropertiesV1 = z.infer<typeof ManualTransportWastePropertiesSchemaV1>;
